import { defineComponent as _defineComponent } from 'vue'
export interface Props {
  index: string | number;
  depth: string | number;
  bgSize: string | null;
  bgImage?: string | null;
  bgPos?: string | null;
  bgColor?: string | null;
  yOffset?: string | number | null;
}


import { reactive, computed, defineComponent } from 'vue';
import type { StyleValue } from 'vue/types/jsx';

import { isString, isNumber } from '@tools/type-guards';

declare module '@vue/runtime-core' {
  export interface GlobalComponents {
    ParallaxLayer: ComponentWithProps<Props>;
  }
}

const __default__ = defineComponent({ name: 'ParallaxLayer' });

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    index: null,
    depth: null,
    bgSize: null,
    bgImage: { default: null },
    bgPos: { default: null },
    bgColor: { default: null },
    yOffset: { default: null }
  },
  setup(__props: any, { expose }) {

const props = __props as { index: string | number, depth: string | number, bgSize: string | null, bgImage: string | null, bgPos: string | null, bgColor: string | null, yOffset: string | number | null };

/**
 * `ParallaxLayer` component properties.
 */


/** ... */
const pos = reactive({ x: 0, y: 0 });

/** ... */
const transform = computed(() => {
  const yOffset = isNumber(props.yOffset)
    ? props.yOffset
    : isString(props.yOffset)
    ? parseFloat(props.yOffset)
    : 0;

  return `translate(${pos.x}px, ${yOffset + pos.y}px)`;
});

/** ... */
const style = computed(() => {
  const style: StyleValue = {
    zIndex: props.index.toString(),
  };

  if (props.bgImage || props.bgColor) {
    if (props.bgImage) style.backgroundImage = `url(${props.bgImage})`;
    else if (props.bgColor) style.backgroundImage = props.bgColor;

    if (props.bgSize) style.backgroundSize = props.bgSize;
    if (props.bgPos) style.backgroundPosition = props.bgPos;
  }

  return style;
});

/**
 * Call externally at any point to update the parallaxing of element.value.
 */
function updatePosition() {
  const depth = isNumber(props.depth) ? props.depth : parseFloat(props.depth);

  const movement = -(window.scrollY * depth);

  pos.y = movement;
}

expose({ updatePosition });

return { __sfc: true,props, pos, transform, style, updatePosition }
}

})